export default __webpack_public_path__ + "static/media/settings-cog.37411b07.svg";